<template>
  <b-container>
    <b-card
      border-variant="danger"
      :header="$t('QRReader.header')"
      header-bg-variant="danger"
      header-text-variant="white"
      align="left"
    >
        <qrcode-stream :track="false" :camera="camera" @decode="onDecode" @init="onInit">
          <div v-show="cameraFrozen" class="validation-layer">
            <div class="validation-notice" v-if="validating">{{ $t('QRReader.validating') }}</div>
            <div class="validation-result" v-if="!validating">
              <div v-if="!isValid" class="invalid">{{ $t('QRReader.invalidQRCode') }}</div>
            </div>
          </div>
        </qrcode-stream>
        <b-row class="mt-3 justify-content-center">
          <b-alert :show="error" variant="danger" class="text-center">{{error}}</b-alert>
        </b-row>
    </b-card>
  </b-container>
</template>

<script>
export default {
  data () {
    return {
      error: null,
      isValid: false,
      validating: false,
      camera: {},
      result: null,
      loading: false,
      firstLoad: true
    }
  },
  mounted () {},
  methods: {
    async onDecode (content) {
      this.result = content

      this.stopCamera()

      this.validating = true
      this.isValid = await this.validate(content)
      this.validating = false

      window.setTimeout(() => {
        this.startCamera()
      }, 2000)
    },

    stopCamera () {
      this.camera = false
    },

    startCamera () {
      // use default settings
      this.camera = null
    },

    validate (content) {
      return new Promise(resolve => {
        window.setTimeout(() => {
          // build different URLs
          let smartdineURL = 'https://smartdine.ch/menu/table/'
          let novotelURL = 'https://novotel.smartdine.ch/menu/table/'
          let ibisURL = 'https://ibis.smartdine.ch/menu/table/'
          let sushibURL = 'https://sushib.smartdine.ch/menu/table/'
          let pastabURL = 'https://pastab.smartdine.ch/menu/table/'
          let syladaURL = 'https://www.smartdine.sylada.com/menu/table/'

          // pretend it's taking really long
          if (content.startsWith(smartdineURL)) {
            resolve(true)
            location.replace(content)
          } else if (content.startsWith(novotelURL)) {
            resolve(true)
            location.replace(content)
          } else if (content.startsWith(ibisURL)) {
            resolve(true)
            location.replace(content)
          } else if (content.startsWith(sushibURL)) {
            resolve(true)
            location.replace(content)
          } else if (content.startsWith(pastabURL)) {
            resolve(true)
            location.replace(content)
          } else if (content.startsWith(syladaURL)) {
            resolve(true)
            location.replace(content)
          } else {
            resolve(false)
          }
        }, 3000)
      })
    },
    async onInit (promise) {
      this.loading = true

      try {
        await promise
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.error = this.$i18n.t('QRReader.notAllowedError')
        } else if (error.name === 'NotFoundError') {
          this.error = this.$i18n.t('QRReader.notFoundError')
        } else if (error.name === 'NotSupportedError') {
          this.error = this.$i18n.t('QRReader.notSupportedError')
        } else if (error.name === 'NotReadableError') {
          this.error = this.$i18n.t('QRReader.notReadableError')
        } else if (error.name === 'OverconstrainedError') {
          this.error = this.$i18n.t('QRReader.overconstrainedError')
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.error = this.$i18n.t('QRReader.streamApiNotSupportedError')
        }
      } finally {
        this.firstLoad = false
        this.loading = false
      }
    }
  },
  computed: {
    cameraFrozen () {
      return this.camera === false || (this.loading && !this.firstLoad)
    }
  }
}
</script>
<style scoped>
.validation-layer {
  position: absolute;
  width: 100%;
  height: 100%;

  background-color: rgba(255, 255, 255, 0.8);
  text-align: center;
  padding: 10px;

  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
}

.validation-notice,
.validation-result {
  font-weight: bold;
  font-size: 1.4rem;
}

.invalid {
  color: #dc3545;
}
</style>



// WEBPACK FOOTER //
// src/components/QRReader.vue